import { AlertCircle, AlertTriangle, CheckCircle2, Info } from "lucide-react";
import cn from "./cn";

const TONES = {
  neutral: { surface: "bg-info-subtle border-info", title: "text-foreground", icon: Info, iconClass: "text-secondary" },
  success: { surface: "bg-success-subtle border-success", title: "text-success", icon: CheckCircle2, iconClass: "text-success" },
  warning: { surface: "bg-warning-subtle border-warning", title: "text-warning", icon: AlertTriangle, iconClass: "text-warning" },
  danger: { surface: "bg-danger-subtle border-danger", title: "text-danger", icon: AlertCircle, iconClass: "text-danger" },
};

/**
 * Notice — a page- or section-level condition and what to do next
 * (DESIGN.md › Components › Notice). Neutral by default; info is never blue.
 * Pass `role="alert"` only for a condition that appears after a user action.
 */
export default function Notice({ tone = "neutral", title, action, role, className, children }) {
  const t = TONES[tone] || TONES.neutral;
  const Icon = t.icon;
  return (
    <div role={role} data-tone={tone} className={cn("flex gap-3 rounded-panel border px-4 py-3 text-body-sm text-foreground", t.surface, className)}>
      <Icon aria-hidden="true" className={cn("mt-px h-4 w-4 shrink-0", t.iconClass)} />
      <div className="min-w-0 flex-1">
        {title ? <p className={cn("font-semibold", t.title)}>{title}</p> : null}
        {children ? <div className={title ? "mt-0.5" : undefined}>{children}</div> : null}
      </div>
      {action ? <div className="shrink-0 self-center">{action}</div> : null}
    </div>
  );
}
